export default function StructuredData({ type = "Organization", data }) {
  const getSchema = () => {
    switch (type) {
      case "Organization":
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Velozent",
          url: "https://velozent.com",
          logo: "https://velozent.com/assets/images/logo.svg",
          description:
            "Velozent - Enhancing Patient Outcomes Through Healthcare IT. We optimize processes and help organizations focus on initiatives that improve patient outcomes.",
          address: {
            "@type": "PostalAddress",
            streetAddress: "5270 California Ave #100",
            addressLocality: "Irvine",
            addressRegion: "CA",
            postalCode: "92679",
            addressCountry: "US",
          },
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+1-909-639-3504",
            contactType: "Customer Service",
            email: "connect@velozent.com",
            areaServed: "US",
            availableLanguage: "English",
          },
          sameAs: [
            // Add social media links if available
          ],
        };
      case "LocalBusiness":
        return {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://velozent.com/#organization",
          name: "Velozent",
          image: "https://velozent.com/assets/images/logo.svg",
          url: "https://velozent.com",
          telephone: "+1-909-639-3504",
          priceRange: "$$",
          address: {
            "@type": "PostalAddress",
            streetAddress: "5270 California Ave #100",
            addressLocality: "Irvine",
            addressRegion: "CA",
            postalCode: "92679",
            addressCountry: "US",
          },
          geo: {
            "@type": "GeoCoordinates",
            latitude: 33.6846,
            longitude: -117.8265,
          },
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            opens: "09:00",
            closes: "17:00",
          },
        };
      case "WebSite":
        return {
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Velozent",
          url: "https://velozent.com",
          description:
            "Velozent - Enhancing Patient Outcomes Through Healthcare IT",
          publisher: {
            "@type": "Organization",
            name: "Velozent",
          },
          potentialAction: {
            "@type": "SearchAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://velozent.com/?s={search_term_string}",
            },
            "query-input": "required name=search_term_string",
          },
        };
      default:
        return data || {};
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getSchema()) }}
    />
  );
}
